define('view/template/confirmation.modal',['require','exports','module','underscore','uikit/uikit'],function(require, exports, module) {
  //prettier-ignore
  var _ = require('underscore'),
      UIKit = require('uikit/uikit');

  var DefaultModalContent = UIKit.ItemView.extend({
    template: function() {
      return '<ui name="imageView" /><ui name="descriptionView" />';
    },

    className: 'content',

    options: {
      textView: UIKit.Text,
      icon: '',
    },

    internalViewOptions: {
      imageView: function() {
        return {
          type: UIKit.ItemView.extend({
            template: function() {
              return '<ui name="iconView" />';
            },
            internalViewOptions: {
              iconView: {
                type: UIKit.ItemView.extend({ template: false }),
                tagName: 'i',
                className: 'icon ' + this.getOption('icon'),
              },
            },
          }),
          className: 'image',
          visible: this.getOption('icon'),
        };
      },
      descriptionView: function() {
        return {
          type: UIKit.Text,
          tagName: 'div',
          className: 'description',
          text: this.getOption('text'),
        };
      },
    },
  });

  var ConfirmationModal = UIKit.Modal.extend({
    options: _.extend({}, UIKit.Modal.prototype.options, {
      closable: true,
      basic: true,
      size: 'small',
      headerText: 'Confirm',
      descriptionView: 'Please confirm',
      icon: 'file text outline',
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
      text: 'Confirmation required',
    }),

    internalViewOptions: {
      content: function() {
        return {
          type: DefaultModalContent,
          text: this.getOption('text'),
          icon: this.getOption('icon'),
        };
      },
    },

    initialize: function() {
      UIKit.Modal.prototype.initialize.apply(this, arguments);

      this.actions.addDeny(
        new UIKit.Button({ text: this.getOption('cancelButtonText'), inverted: true, color: 'basic' })
      );
      this.actions.addApprove(new UIKit.Button({ text: this.getOption('confirmButtonText'), color: 'positive' }));
      this.header.text = this.getOption('headerText');
    },
  });
  module.exports = ConfirmationModal;
});

